<div class="flex-column flex-100 mbs-2" *ngIf="!!this.case">
    @if(this.loadingSignature) {
    <app-spinner [minHeight]="200"></app-spinner>
    }
    <div class="flex-100 flex-row align-end-center header-buttons" style="height: 36px;">
        <!-- Add provision -->
        <button mat-icon-button [matTooltip]="('modules.cases.provisions-detail.agregar-esquema-prestacional' | exp:'':'Agregar esquema prestacional')" [color]="'primary'"
            (click)="this.openAddProvisionDialog()" id="addArrangementButton" [disabled]="(!this.case?.active || this.case.rejected)">
            <mat-icon>add_circle_outlined</mat-icon>
        </button>

        <button mat-icon-button [disabled]="this.selectionProvisionFees?.selected?.length == 0 || !this.case?.active || this.case.rejected"
            [matMenuTriggerFor]="menuGlobalActions" (click)="$event.stopPropagation()" [matTooltip]="('modules.cases.provisions-detail.tooltips.actions' | exp:'':'Acciones')">
            <mat-icon class="cursor-pointer text-secondary" [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"
                [ngClass]="{ 'line-icon-grey': this.selectionProvisionFees?.selected?.length == 0 }"></mat-icon>
        </button>
    </div>
    <ng-container *ngIf="!this.loadingGetProvisions; else loadingProvisions">
        <table tabindex="0" mat-table style="width: 100%; border-radius: 10px;" [dataSource]="this.dataSource"
            multiTemplateDataRows>
            <!-- arrow Column -->
            <ng-container matColumnDef="arrow">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2"></th>
                <td mat-cell *matCellDef="let data" class="arrow-column">
                    <div *ngIf="!!data.provisionFees && data.provisionFees.length > 0" style="border:none !important">
                        <mat-icon [color]="'primary'" style="margin-top: 0.8rem;">
                            {{ data == expandedElement ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                        </mat-icon>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef style="display:none"></td>
            </ng-container>

            <!-- name Column -->
            <ng-container matColumnDef="provision">
                <th mat-header-cell [attr.rowspan]="2" *matHeaderCellDef>
                    {{ this.supply ? ('modules.cases.provisions-detail.table.column.practice-supply' | exp:'':'Insumo') : ('modules.cases.provisions-detail.table.column.practice' | exp:'':'Práctica') }}
                </th>
                <td mat-cell *matCellDef="let data"
                    class="flex align-start-none margin-top-14 border-none padding-top-1">
                    <div #practicesTable *ngIf="!!data.provisionFees && data.provisionFees.length > 0"
                        class="border-none width-100" [ngStyle]="{ 'max-width': !this.isExpanded ? '5rem' : '' }">
                        <div class="flex-row align-center-center practice-name-row">
                            <span class="subtitle-3 text-primary-darker text-ellipsis"
                                [matTooltip]="getPracticeTooltipText(data)"
                                matTooltipClass="multiline-tooltip"
                                matTooltipPosition="below">
                                {{ !!data.practice?.name ? data.practice.name : ('modules.cases.provisions-detail.labels.no-data' | exp:'':'Sin datos') }}
                            </span>
                            @if (isPatientSelfCareProvision(data)) {
                                <app-self-care-chip></app-self-care-chip>
                            }
                        </div>
                        <!--
                        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOffsetX]="0"
                            [cdkConnectedOverlayOffsetY]="10" [cdkConnectedOverlayOrigin]="originOverlay"
                            [cdkConnectedOverlayOpen]="isTooltipOpen" [cdkConnectedOverlayWidth]="200">
                            <div class="flex-column" *ngIf="practiceForTooltip === data.practice.name">
                                <div class="bg-secondary-darker mat-font-verysmall-px pxs-2 pys-1">
                                    <span class=" text-primary-lighter">
                                        {{ practiceForTooltip }}
                                    </span>
                                </div>
                                <div class="bg-secondary-darker mat-font-verysmall-px pxs-2 pys-1"
                                    *ngFor="let code of practiceArrangementForTooltip">
                                    <div class="flex-row flex-none gap-0-1em">
                                        <span class="text-primary-lighter">{{!!code.id?
                                            code.arrangementName : ('modules.cases.provisions-detail.labels.no-agreement' | exp:'':'Sin convenio')}} - {{code.code}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        -->
                    </div>
                </td>
                <!-- TOTALS FOOTER -->
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="isExpanded ? columnsToDisplayExpanded.length : columnsToDisplayCollapsed.length" class="border-radius-0-0-10-0">
                    <div class="flex-column">
                    <div *ngIf="this.isExpanded" class="pxs-2 row-wrap align-start-center border-none footer-gap pys-1">
                        <div class="flex-row align-start-center gap-0-5em pys-1">
                            <span class="subtitle-6 text-primary-darker">{{ 'modules.cases.case-indicators.practice.title' | exp:'':'Prácticas' }}:</span>
                            <span class="subtitle-6 text-primary">{{ !!this.dataSource.data ? this.dataSource.data.length : 0 }}</span>
                            @if (this.selectionProvisions.selected.length > 0) {
                                    <span class="selected-chip subtitle-6">
                                        {{selectionProvisionFees.selected.length}}
                                    </span>
                            }
                        </div>
                        <div class="flex-row align-start-center gap-0-5em pys-1">
                            <span class="subtitle-6 text-primary-darker">{{ 'modules.cases.provisions-detail.total-agendado' | exp:'':'Total Agendado' }}:</span>
                            <span class="subtitle-6 text-primary">{{ !btnsDisabled ? (totalValueFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}</span>
                            @if (this.selectionProvisions.selected.length > 0) {
                                        <span class="selected-chip subtitle-6">
                                            {{ this.subTotalValueFooter ? (this.subTotalValueFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}
                                        </span>
                            }
                        </div>
                        <div class="flex-row align-start-center gap-0-5em pys-1">
                            <span class="subtitle-6 text-primary-darker">{{ 'modules.cases.provisions-detail.total-facturable' | exp:'':'Total Facturable' }}:</span>
                            <span class="subtitle-6 text-primary">
                                {{ !btnsDisabled ? (totalInvoicedFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}
                            </span>
                            @if (this.selectionProvisions.selected.length > 0) {
                                    <span class="selected-chip subtitle-6">
                                        {{ this.subTotalInvoicedFooter ? (this.subTotalInvoicedFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}
                                    </span>
                            }
                        </div>
                        <div class="flex-row align-start-center gap-0-5em pys-1">
                            <span class="subtitle-6 text-primary-darker">{{ 'modules.cases.provisions-detail.total-debitable' | exp:'':'Total Debitable' }}:</span>
                            <span class="subtitle-6 text-primary">{{ !btnsDisabled ? (totalDebitedFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}</span>
                            @if (this.selectionProvisions.selected.length > 0) {
                                    <span class="selected-chip subtitle-6">
                                        {{ this.subTotalDebitedFooter ? (this.subTotalDebitedFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}
                                    </span>
                            }
                        </div>
                        <div class="flex-row align-start-center gap-0-5em pys-1">
                            <span class="subtitle-6 text-primary-darker">{{ 'modules.cases.provisions-detail.total-informado' | exp:'':'Total Informado' }}:</span><span
                                class="subtitle-6 text-primary">{{ !btnsDisabled ? (totalDeliveredFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}</span>
                                @if (this.selectionProvisions.selected.length > 0) {
                                        <span class="selected-chip subtitle-6">
                                            {{ this.subTotalDeliveredFooter ? (this.subTotalDeliveredFooter | currency: 'ARS':'symbol':'1.2') : '$ 0' }}
                                        </span>
                                }
                        </div>
                    </div>
                    </div>

                </td>
            </ng-container>

            <!-- checkBox Column -->
            <ng-container matColumnDef="checkProvisionFee">
                <th mat-header-cell [attr.rowspan]="2" *matHeaderCellDef>
                    <div class="align-center-center">
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selectionProvisionFees.hasValue() && isAllSelected()"
                            [indeterminate]="selectionProvisionFees.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row" style="min-width: 0px !important;">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell pxs-3">
                        <mat-checkbox class="align-center" (click)="$event.stopPropagation()" [indeterminate]="
                    this.isAgreementsIndeterminated(row) &&
                    this.selectionProvisionFees.isSelected(data)
                 " (change)="onChangeChildProvisionFee(row, data)" [checked]="this.verifyProvisionFeeSelection(data)">
                        </mat-checkbox>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- frequency Column -->
            <ng-container matColumnDef="frequency">
                <th mat-header-cell [attr.rowspan]="2" *matHeaderCellDef>
                    {{ this.supply ? ('modules.cases.provisions-detail.table.column.quantity' | exp:'':'Cantidad') : ('modules.cases.provisions-detail.table.column.frequency' | exp:'':'Frecuencia') }}
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell">
                        <div class="flex-column gap-0-5em">
                            <div [matTooltip]="data?.authorization?.number ? data?.authorization?.number : ('modules.cases.provisions-detail.labels.no-authorization' | exp:'':'Sin autorización')"
                                [matTooltipDisabled]="isExpanded"
                                [ngClass]="{ 'no-frequency': data?.frequency?.unit == ('modules.cases.provisions-detail.labels.not-specified' | exp:'':'Sin especificar') || data?.frequency?.amount == null }">
                                {{ this.frequencyOfProvision(data) }}
                            </div>
                            @if(data?.frequency?.allowedHours >= 1 ) {
                                {{ data.frequency.allowedHours | i18nPlural: {
                                        '=1': ('modules.cases.provisions-detail.labels.hour-singular' | exp:'':'1 h diaria'),
                                        'other': ('modules.cases.provisions-detail.labels.hour-plural' | exp: { count: data.frequency.allowedHours } : (data.frequency.allowedHours + ' hs diarias'))
                                    }
                                }}
                            }
                        </div>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Valor Unitario -->
            <!-- total Column -->
            <ng-container matColumnDef="fee">
                <th mat-header-cell [attr.rowspan]="2" *matHeaderCellDef>
                    <div class="flex-column align-center-center">
                        <span>{{ 'modules.cases.provisions-detail.table.column.sale' | exp:'':'Venta' }}</span>
                        <span>{{ 'modules.cases.provisions-detail.table.column.unit-price' | exp:'':'Unitario' }}</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row" style="width: 5rem;">
                    <div *ngFor="let data of row.provisionFees; let last = last; let idRecord = index"
                        class="inner-cell" (mouseover)="enableButtonEditForProvisionFeeHover(data.id)"
                        (mouseleave)="enableButtonEditForProvisionFeeHover(0)">
                        <div *ngIf="!!this.verifyVariationOnPrice(row, data)">
                            <div cdkOverlayOrigin #tooltipOverlay="cdkOverlayOrigin" (mouseenter)="setVariationTooltip(data)"
                                (mouseleave)="setVariationTooltip(null)">
                                <div class="flex-row" style="cursor: pointer;">
                                    <span>{{ !!totalUnitOfProvision(row, data) ? (totalUnitOfProvision(row,
                                        data).toFixed(2) | currency: 'ARS':'symbol':'1.2') : '-' }}</span>
                                    <mat-icon [style.width.px]="8" [style.height.px]="8" [svgIcon]="'ellipseRed'"
                                        class="flex pb-2"></mat-icon>
                                </div>
                            </div>
                            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOffsetX]="-50"
                                [cdkConnectedOverlayOffsetY]="5" [cdkConnectedOverlayOrigin]="tooltipOverlay"
                                [cdkConnectedOverlayOpen]="hoveredProvisionFeeTooltip === data" [cdkConnectedOverlayWidth]="250">
                                <div class="flex-column flecha-lado-izquierdo-arriba">
                                    <div class="bg-secondary-lighter mat-font-verysmall-px pxs-2 pys-1"
                                        *ngFor="let item of this.getVariationPriceTooltip(row, data)">
                                        <div class="body-3 flex-row flex-none gap-0-1em">
                                            <span>
                                                {{ item.fee != -1 ? (item.fee.toFixed(2) | currency:
                                                'ARS':'symbol':'1.2') : ('modules.cases.provisions-detail.labels.not-defined' | exp:'':'No definido') }}: {{ item.fromDate | date:
                                                'dd/MM/yyyy' }} - {{ !!item.toDate ? (item.toDate | date: 'dd/MM/yyyy')
                                                : ('modules.cases.provisions-detail.labels.onwards' | exp:'':'en adelante') }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <div *ngIf="!this.verifyVariationOnPrice(row, data)">
                            <span style="min-width: 50px;">{{ !!totalUnitOfProvision(row, data) ?
                                (totalUnitOfProvision(row, data) | currency: 'ARS':'symbol':'1.2') : '-' }}</span>
                        </div>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Total Amount - Total Agendado -->
            <ng-container matColumnDef="totalAmount">
                <th mat-header-cell [attr.rowspan]="2" *matHeaderCellDef>
                    <div class="flex-column align-center-center">
                        <span>{{ 'modules.cases.provisions-detail.table.column.total' | exp:'':'Total' }}</span>
                        <span>{{ 'modules.cases.provisions-detail.table.column.scheduled' | exp:'':'Agendado' }}</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell"
                        [ngClass]="{'marked-top': !!data?.paintedType}">
                        <span matTooltip="{{ this.getTooltipUnitDescription(row) }}">
                            {{ !btnsDisabled ? totalOfProvision(row, data) : '-' }}
                        </span>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Total Realizado -->
            <ng-container matColumnDef="totalRealized">
                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">
                    <div class="state-header flex-column align-center-center"
                        style="border-radius: 10px 0px 0px 0px; border-right: none !important; width: 100%; height: 34px;">
                        {{ 'modules.cases.provisions-detail.table.column.completed' | exp:'':'Realizado' }}
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell">
                        <span matTooltip="{{ this.getTooltipUnitDescription(row) }}">
                            {{ !btnsDisabled ? totalRealizedOfProvision(row, data) : '-' }}
                        </span>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Valor Total -->
            <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="flex-column align-start-none">
                        <span>{{ 'modules.cases.provisions-detail.table.column.value' | exp:'':'Valor' }}</span>
                        <span>{{ 'modules.cases.provisions-detail.table.column.total-lower' | exp:'':'total' }}</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell">
                        {{ !!totalValueOfProvision(data) ? (totalValueOfProvision(data) | currency:
                        'ARS':'symbol':'1.2') : '-' }}
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Facturable -->
            <ng-container matColumnDef="billed">
                <th mat-header-cell *matHeaderCellDef class="state-header">{{ 'modules.cases.provisions-detail.table.column.billable' | exp:'':'Facturable' }}</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell">
                        <span matTooltip="{{ this.getTooltipUnitDescription(row) }}">
                            {{ !btnsDisabled ? invoicedOfProvision(row, data) : '-' }}
                        </span>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Debitable -->
            <ng-container matColumnDef="debited">
                <th mat-header-cell *matHeaderCellDef class="state-header">{{ 'modules.cases.provisions-detail.table.column.debitable' | exp:'':'Debitable' }}</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell">
                        <span matTooltip="{{ this.getTooltipUnitDescription(row) }}">
                            {{ !btnsDisabled ? debitedOfProvision(row, data) : '-' }}
                        </span>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Informado -->
            <ng-container matColumnDef="fullyReported">
                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter" style="border-right: 1px solid var(--color-white);">
                    <div class="state-header flex-column align-center-center"
                        style="border-radius: 0px 10px 0px 0px; border-left: none !important; height: 34px;">
                        <!-- <span>Total</span> -->
                        <span>{{ 'modules.cases.provisions-detail.table.column.reported' | exp:'':'Informado' }}</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last" class="inner-cell">
                        <span matTooltip="{{ this.getTooltipUnitDescription(row) }}">
                            {{ !btnsDisabled ? fullyDeliveredOfProvision(row, data) : '-' }}
                        </span>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- PROVISION STATE -->
            <!-- validity Column -->
            <ng-container matColumnDef="validity">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">{{ 'modules.cases.provisions-detail.table.column.status' | exp:'':'Estado' }}</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let data of row.provisionFees; let last = last; let idRecord = index"
                        class="inner-cell-auth inner-cell">
                        <mat-chip-listbox>
                            <mat-chip [ngStyle]="{
                                        'background-color': this.getBackgroundColorAuthorizationState(data),
                                        color: this.getColorAuthorizationState(data)
                                    }" matTooltip="{{
                                            data.authorization
                                            ? '#' + data.authorization.authorizationNumber + ' - ' + this.generalService.getAuthorizationState(data.authorization)
                                            : this.generalService.getAuthorizationState(data.authorization)
                                    }}" (click)="this.onClickAuthorization(data); $event.stopPropagation()"
                                matBadge="P" [matBadgeHidden]="data.arrangementId" matBadgeColor="accent"
                                matBadgeSize="small">
                                <span class="mat-small cursor-pointer">
                                    {{ this.generalService.getAuthorizationState(data.authorization) | firstLetterWordsIntoString }}
                                </span>
                            </mat-chip>
                        </mat-chip-listbox>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="vigency">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">{{ 'modules.cases.provisions-detail.table.column.validity' | exp:'':'Vigencia' }}</th>
                <td mat-cell *matCellDef="let provision" style="width:6rem;">
                    <div *ngFor="let data of provision.provisionFees; let last = last; let idRecord = index"
                        class="inner-cell">
                        <div class="flex-row align-center-center">
                            <div>
                                {{ !!provisionFeeFromDate(data) ? (provisionFeeFromDate(data) | date: 'dd/MM/yyyy') : ''
                                }}
                                {{ provisionFeeToDate(data) | date: 'dd/MM/yyyy' }}
                            </div>
                        </div>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!--ACTIONS COLUMN-->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2"></th>
                <td mat-cell *matCellDef="let prov" style="min-width: 1rem !important;">
                    <div *ngFor="let data of prov.provisionFees; let last = last; let idRecord = index"
                        class="inner-cell">
                        <button mat-icon-button (click)="$event.stopPropagation()" [matTooltip]="('modules.cases.provisions-detail.tooltips.actions' | exp:'':'Acciones')"
                            [disabled]="(!this.case?.active || this.case.rejected)"
                            [matMenuTriggerFor]="menuActions"
                            [matMenuTriggerData]="{ provision: prov, provisionFee: data }">
                            <mat-icon class="cursor-pointer text-secondary"
                                [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"
                                [ngClass]="{ 'line-icon-grey': (!this.case?.active || this.case.rejected) }">
                                </mat-icon>
                        </button>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns 1-->
            <!-- Agreements -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let data"
                    [attr.colspan]="isExpanded ? columnsToDisplayExpanded.length : columnsToDisplayCollapsed.length"
                    style="padding-left:0 !important;">
                    <div class="example-element-detail"
                        [@detailExpand]="data.id == expandedElement ? 'expanded' : 'collapsed'">
                        <!-- Agreements -->
                        <div class="flex-column">
                            <div class="shadow"></div>
                            <!-- GRID / agreements-grid -->
                            <!-- GRID WITH 4 COLUMNS TO NOT EXPANDED  -->
                            <!-- GRID WITH 9 COLUMNS TO EXPANDED     -->
                            <div class="agreements-grid" style="width: 100%"
                                [ngClass]="{ 'agreements-grid-cant-columns-13': this.isExpanded, 'agreements-grid-cant-columns-5': !this.isExpanded}">
                                <!-- HEADER -->
                                <div class="bg-primary-lighter agreement-header"></div>
                                <!-- Checkbox -->
                                <div class="bg-primary-lighter agreement-header">
                                    <span class="subtitle-3 text-primary">{{ 'modules.cases.provisions-detail.acuerdo-prestacional' | exp:'':'Acuerdo prestacional' }}</span>
                                </div>
                                <div *ngIf="this.isExpanded" class="bg-primary-lighter agreement-header">
                                    <span class="subtitle-3 text-primary">{{ 'modules.cases.provisions-detail.total-agendado' | exp:'':'Total Agendado' }}</span>
                                </div>
                                <div *ngIf="!this.isExpanded" style="text-align: center;"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.table.column.specialty' | exp:'':'Especialidad' }}</span>
                                </div>
                                <div style="text-align: center;"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.table.column.cost' | exp:'':'Costo' }}</span>
                                </div>
                                <div style="text-align: center;" *ngIf="this.isExpanded"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.table.column.completed-female' | exp:'':'Realizadas' }}</span><!--  -->
                                </div>
                                <div *ngIf="this.isExpanded" style="text-align: center;"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.no-realizadas' | exp:'':'No realizadas' }}</span>
                                </div>
                                <div *ngIf="this.isExpanded" style="text-align: center;"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.table.column.billable-plural' | exp:'':'Facturables' }}</span>
                                </div>
                                <div *ngIf="this.isExpanded" style="text-align: center;"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.table.column.debitable-plural' | exp:'':'Debitables' }}</span>
                                </div>
                                <div *ngIf="this.isExpanded" style="text-align: center;"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.table.column.reported-plural' | exp:'':'Informadas' }}</span>
                                </div>
                                <div *ngIf="this.isExpanded" style="text-align: center;"
                                    class="text-primary bg-primary-lighter agreement-header">
                                    <span class="subtitle-3">{{ 'modules.cases.provisions-detail.table.column.validity' | exp:'':'Vigencia' }}</span>
                                </div>
                                <!-- Button edit and delete together-->
                                <div *ngIf="this.isExpanded" style="text-align: center;"
                                    class="bg-primary-lighter agreement-header">
                                    <button [style.grid-column-start]="this.isExpanded ? 11 : 4" [color]="'primary'" [disabled]="(
                                        isLoadingCreatingAgreement$ | async)
                                        || !this.case.active
                                        || (!!this.case['caseDerivations'] && this.case['caseDerivations'].length > 0)
                                        || isAddAgreementDisabledForSelfCare(data)"
                                        mat-icon-button (click)="this.openAddAgreementDialog(data)"
                                        [matTooltip]="('modules.cases.provisions-detail.crear-acuerdo-prestacional' | exp:'':'Crear acuerdo prestacional')">
                                        <mat-icon>add_circle_outlined</mat-icon>
                                    </button>
                                </div>
                                <!-- END HEADER -->
                                <!-- CONTENT GRID -->
                                <ng-container *ngFor="let agreement of data.agreements" style="height: 52px;">
                                    <!-- Checkbox -->
                                    <!-- Expanded/Not expanded #1 -->
                                    <mat-checkbox class="align-center-center grid-text-center"
                                        (click)="$event.stopPropagation()" (change)="onChangeChild(data, agreement)"
                                        [disabled]="!isPracticeSelected(data)"
                                        [checked]="this.selectionAgreements?.isSelected(agreement) && isPracticeSelected(data)">
                                    </mat-checkbox>
                                    <!-- View expanded -->
                                    <ng-container *ngIf="this.isExpanded; else collapseAgreements">
                                        <!-- Expanded #3 - Name provider -->
                                        <div class="flex-row align-start-center grid-text-center pls-3 self-care-agreement-cell">
                                            @if (isPatientSelfCareProvision(data)) {
                                                <app-patient-provider-cell [patient]="case?.patient"></app-patient-provider-cell>
                                            } @else {
                                                <span>{{!!agreement?.provider
                                                    ? this.entitiesFacade?.getProvidersFullName(agreement?.provider)
                                                    : ''}}
                                                </span>
                                                <button mat-icon-button *ngIf="agreement?.provider?.hasSignature"
                                                    color="accent" [attr.aria-label]="('modules.cases.provisions-detail.firma-del-prestador' | exp:'':'Firma del prestador')"
                                                    [matTooltip]="('modules.cases.provisions-detail.firma-del-prestador' | exp:'':'Firma del prestador')"
                                                    (click)="this.onClickSignature(agreement?.provider)">
                                                    <mat-icon>verified</mat-icon>
                                                </button>
                                                <span *ngIf="!agreement?.provider?.active" class="custom-chip mls-1">
                                                    {{ ('modules.cases.provisions-detail.labels.inactive' | exp:'':'Inactivo') }}
                                                </span>
                                            }
                                        </div>
                                        <!-- Expanded #4 - Total agendado -->
                                        <div class="align-center-center grid-text-center">
                                            <span class="cursor-pointer "
                                                matTooltip="{{ this.getTooltipUnitDescription(data) }}"
                                                [ngClass]="{ autoProviderFee: true }">
                                                {{ agreementTotal(data, agreement) }}
                                            </span>
                                        </div>
                                        <!-- Expanded #5 - Costo - fee -->
                                        <div class="align-center-center grid-text-center">
                                            @if (!isPatientSelfCareProvision(data)) {
                                            <span [ngClass]="{ autoProviderFee: true }">
                                                {{ agreement?.providerFee | currency: 'ARS':'symbol':'1.2' }}
                                            </span>
                                            } @else {
                                            <span>-</span>
                                            }
                                        </div>
                                        <!-- Expanded #6 - Realizadas -->
                                        <div class="align-center-center grid-text-center">
                                            <span class="cursor-pointer "
                                                matTooltip="{{ this.getTooltipUnitDescription(data) }}">{{
                                                agreementPerformed(data, agreement)
                                                }}</span>
                                        </div>
                                        <!-- Expanded #7 - No realizadas -->
                                        <div class="align-center-center grid-text-center">
                                            <!-- Expanded #6 -->
                                            <span class="cursor-pointer "
                                                matTooltip="{{ this.getTooltipUnitDescription(data) }}">{{
                                                agreementNotPerformed(data, agreement)
                                                }}</span>
                                        </div>
                                        <!-- Expanded #8 - Facturables -->
                                        <div class="align-center-center grid-text-center">
                                            <span class="cursor-pointer"
                                                matTooltip="{{ this.getTooltipUnitDescription(data) }}">{{
                                                agreementInvoiced(data, agreement)
                                                }}</span>
                                        </div>
                                        <!-- Expanded #9 - Debitables -->
                                        <div class="align-center-center grid-text-center">
                                            <span class="cursor-pointer "
                                                matTooltip="{{ this.getTooltipUnitDescription(data) }}">{{
                                                agreementDebited(data, agreement)
                                                }}</span>
                                        </div>
                                        <!-- Expanded #10 - Informadas -->
                                        <div class="align-center-center grid-text-center">
                                            <span class="cursor-pointer "
                                                matTooltip="{{ this.getTooltipUnitDescription(data) }}">
                                                {{ agreementInformed(data, agreement) }}
                                            </span>
                                        </div>
                                        <!-- Expanded #11 - Fecha -->
                                        <div class="align-center-center grid-text-center" *ngIf="this.isExpanded">
                                            <span>
                                                {{ agreement?.fromDate | date: 'dd/MM/yyyy' }}
                                                {{ agreement?.toDate | date: 'dd/MM/yyyy' }}
                                            </span>
                                        </div>
                                        <!-- Expanded #12 - Button Edit -->
                                        <div class="align-center grid-text-center">
                                            <button mat-icon-button (click)="$event.stopPropagation()"
                                                [matTooltip]="('modules.cases.provisions-detail.tooltips.actions' | exp:'':'Acciones')" [matMenuTriggerFor]="menuAgreement"
                                                [disabled]="(!this.case?.active || this.case.rejected)"
                                                [matMenuTriggerData]="{
                                                provision: data,
                                                agreement: agreement}">
                                                <mat-icon class="cursor-pointer text-secondary"
                                                    [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"
                                                    *ngIf="this.isExpanded"></mat-icon>
                                            </button>
                                        </div>
                                    </ng-container>
                                    <!-- View NOT expanded -->
                                    <ng-template #collapseAgreements>
                                        <!-- Name provider -->
                                        @if (isPatientSelfCareProvision(data)) {
                                            <app-patient-provider-cell [patient]="case?.patient"></app-patient-provider-cell>
                                        } @else {
                                            <span class="align-center">
                                                {{
                                                !!agreement?.provider
                                                ? this.entitiesFacade?.getProvidersFullName(
                                                agreement?.provider
                                                )
                                                : ''
                                                }}
                                                <span *ngIf="!agreement?.provider?.active" class="mls-1 custom-chip"
                                                    [matTooltip]="('modules.cases.provisions-detail.labels.inactive' | exp:'':'Inactivo')" style> I</span>
                                            </span>
                                        }

                                        <!-- Specialties provider -->
                                        @if (!isPatientSelfCareProvision(data)) {
                                        <span class="align-center my-3" [matTooltip]="
                                    this.entitiesFacade.getProviderSpecialties(
                                       agreement?.provider?.specialties
                                    )
                                 ">
                                            {{
                                            this.entitiesFacade.getProviderSpecialties(
                                            agreement?.provider?.specialties | slice: 0:2
                                            )
                                            }}...
                                        </span>
                                        <!-- Provider fee -->
                                        <div class="grid-text-center align-center my-3">
                                            <span>{{
                                                agreement?.providerFee | currency: 'ARS':'symbol':'1.2'
                                                }}</span>
                                        </div>
                                        }
                                    </ng-template>
                                </ng-container>
                                <!-- END CONTENT GRID -->
                                <!-- Button Crear acuerdo -->
                                <div
                                    [ngClass]="{ '.agreements-grid-start-1-end-10': this.isExpanded, '.agreements-grid-start-1-end-4': !this.isExpanded }">
                                </div>
                                <div [style.grid-column-start]="this.isExpanded ? 11 : 4">
                                    <button *ngIf="!this.isExpanded" [color]="'primary'" [disabled]="
                                        (isLoadingCreatingAgreement$ | async)
                                        || !this.case.active
                                        || (!!this.case['caseDerivations'] && this.case['caseDerivations'].length > 0)
                                        || isAddAgreementDisabledForSelfCare(data)"
                                        mat-icon-button (click)="this.openAddAgreementDialog(data)"
                                        [matTooltip]="('modules.cases.provisions-detail.crear-acuerdo-prestacional' | exp:'':'Crear acuerdo prestacional')">
                                        <mat-icon>add_circle_outlined</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <!-- End GRID -->
                        </div>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!--Containers used to generate a row under the table header for attentions spinner-->
            <ng-container matColumnDef="progressBarProvisions">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="6">
                    <mat-progress-bar [mode]="'determinate'" [value]="100"
                        progressBarId="attentionsLoading"></mat-progress-bar>
                </th>
            </ng-container>

            <ng-container matColumnDef="progressBarAttentions">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="5" class="border-none">
                    <mat-progress-bar [mode]="'indeterminate'" progressBarId="attentionsLoading"
                        *ngIf="this.loadingGetAttentions"></mat-progress-bar>
                    <mat-progress-bar [mode]="'determinate'" [value]="100" progressBarId="attentionsLoading"
                        *ngIf="!this.loadingGetAttentions"></mat-progress-bar>
                </th>
            </ng-container>

            <ng-container matColumnDef="progressBarState">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="3">
                    <mat-progress-bar [mode]="'determinate'" [value]="100"
                        progressBarId="attentionsLoading"></mat-progress-bar>
                </th>
            </ng-container>

            <ng-container matColumnDef="states">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="4">
                    {{ 'modules.cases.provisions-detail.table.column.states' | exp:'':'Estados' }}
                </th>
                <td mat-cell class="display-none" *matCellDef></td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <!-- Rows definitions -->
            <tr mat-header-row *matHeaderRowDef="isExpanded ? headerColumns : columnsToDisplayCollapsed"></tr>
            <tr mat-header-row *matHeaderRowDef="this.isExpanded ? statesColumns : null" style="height: fit-content;">
            </tr>
            <tr mat-header-row *matHeaderRowDef="['progressBarProvisions', 'progressBarAttentions', 'progressBarState']"
                class="height-4px">
            </tr>
            <tr mat-row *matRowDef="let element; columns: isExpanded ? columnsToDisplayExpanded : columnsToDisplayCollapsed"
                class="bg-on-hover parentShowOnHover cursor-pointer"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element.id ? null : element.id"
                (mouseover)="enableButtonEditForProvisionHover(element.id)"
                (mouseleave)="enableButtonEditForProvisionHover(0)">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="bg-on-hover parentShowOnHover example-detail-row"></tr>
            <tr mat-footer-row *matFooterRowDef="isExpanded ? columnsToDisplayExpanded : columnsToDisplayCollapsed"
                [ngClass]="{ 'bg-primary-lighter': this.isExpanded }">
            </tr>
        </table>
    </ng-container>

    <ng-template #loadingProvisions>
        <div class="align-center-center height-100">
            <!-- <mat-spinner diameter="60"></mat-spinner> -->
        </div>
    </ng-template>
</div>

<!-- ADD / UPDATE PROVISION -->
<ng-template #provisionTemplate>
    <form class="flex-column flex-100" [formGroup]="this.formProvision" (submit)="onClickConfirmFormProvision()"
        style=" width: 100vh">
        <div class="flex-column">
            <div class="flex-row space-between-start" [ngClass]="{ 'mbs-3': !this.isAddModeProvision }">
                <div class="flex-column align-start-start gap-gappx flex-50">
                    <!-- Practice -->
                    <div class="flex-row align-start-center gap-0-5em" [hidden]="this.isAddModeProvision">
                        <span class="text-primary">{{ 'modules.cases.provisions-detail.practica' | exp:'':'Práctica' }}: </span>
                        <span class="subtitle-2 text-primary-darker">{{
                            !!this.provisionToWork?.practice?.name
                            ? this.provisionToWork.practice.name
                            : ''
                            }}</span>
                    </div>
                    <!-- Arrangement -->
                    <div class="flex-row align-start-center gap-0-5em" [hidden]="this.isAddModeProvision">
                        <span class="text-primary">{{ 'modules.cases.provisions-detail.convenio' | exp:'':'Convenio' }}: </span>
                        <span class="subtitle-2 text-primary-darker">{{
                            !!this.arrangementSelected ? this.arrangementSelected.name : ('modules.cases.provisions-detail.labels.no-agreement' | exp:'':'Sin convenio')
                            }}</span>
                    </div>
                </div>
                <!-- Retroactive -->
                <div class="flex-row flex-50 align-end-center"
                    *ngIf="isShowRetroactive && this.provisionFeeToWork?.arrangementId == null">
                    <mat-slide-toggle [color]="'primary'" (change)="toogleRetroactive($event.checked)">
                        <span class="text-primary subtitle-2">{{ 'modules.cases.provisions-detail.labels.retroactive' | exp:'':'Retroactivo' }}</span>
                    </mat-slide-toggle>
                </div>
            </div>

            <!-- Radiobutton arrangements - hidden if isShowRetroactive = false -->
            <div class="flex-column" *ngIf="!isShowRetroactive && !!isAddModeProvision">
                <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.convenio' | exp:'':'Convenio' }}: </span>
                <mat-radio-group class="flex-column subtitle-3 text-primary-darker mbs-3" formControlName="arrangement"
                    [name]="this.ARRANGEMENT" (change)="this.radioButtonArrangementSelected($event)">
                    <mat-radio-button *ngFor="let element of this.caseArrangementsForSelection" [value]="element.id" class=""
                        style="width: max-content;">
                        {{ element.name }}
                    </mat-radio-button>
                    <mat-radio-button [value]="'S/C'" class="">{{ 'modules.cases.provisions-detail.sin-convenio' | exp:'':'Sin convenio' }}</mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Practice -->
            <div class="flex-column" [hidden]="!this.isAddModeProvision">
                <span class="subtitle-3 text-primary-darker">{{ ('modules.cases.provisions-detail.labels.select-practice' | exp:'':'Seleccione práctica') }} *</span>
                <app-select-searching-input class="" [name]="this.PRACTICE" [nameSearching]="this.PRACTICE_SEARCHING"
                    [form]="this.formProvision" (selected)="this.onSelectPractice($event)"
                    [elements]="this.practicesToShow" [calculateId]="this.calculateIdPractice"
                    [calculateName]="this.calculateNamePractice"
                    [defaultValue]="!!this.provisionToWork ? this.provisionToWork.practiceId : null"
                    [placeholderSearching]="('common.search' | exp:'':'Buscar...')" [disabled]="this.isAddModeProvision ? false : true">
                </app-select-searching-input>
            </div>
            <!-- Frequency   -->
            <div [formGroupName]="this.FRECUENCY" class="flex-row space-between-center flex-100" style="gap: 2.5em;"
                *ngIf="!isRetroactive">
                <!-- AMOUNT input -->

                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.visit-frequency' | exp:'':'Frecuencia de visita' }} *</span>
                    <div class="flex-row gap-0-5em" style="align-items: baseline;">
                        <div class="flex-40">
                            <app-number-input [name]="this.AMOUNT" [form]="this.formFrequency" [minValue]="0"
                                [money]="false">
                            </app-number-input>
                        </div>
                        <span class="subtitle-3 text-primary-darker flex-10"> {{ 'modules.cases.provisions-detail.labels.por' | exp:'':'por' }}</span>
                        <div class="flex-50">
                            <!-- UNIT input -->
                            <app-select-input [name]="this.UNIT" [form]="this.formFrequency"
                                [placeholder]="this.supply ? ('modules.cases.provisions-detail.placeholders.unit' | exp:'':'Unidad') : ('modules.cases.provisions-detail.placeholders.period' | exp:'':'Período')"
                                [elements]="this.supply ? this.provisionsUnit : this.provisionsFrequencyUnit"
                                [calculateId]="this.calculateIdUnit" [calculateName]="this.calculateNameUnit">
                            </app-select-input>
                        </div>
                        <!-- Hours  input -->
                    </div>
                </div>
                @if(isGuard()){
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.daily-hours' | exp:'':'Horas diarias' }} *</span>
                    <app-number-input class="flex-50" [name]="this.HOURS" [form]="this.formFrequency" [minValue]="1"
                        [money]="false">
                    </app-number-input>
                </div>
                }
            </div>
            <!-- Validity / Vigencia -->
            <div class="flex-column">
                <div class="flex-row align-space-between-center flex-100">
                    <!-- From -->
                    <!-- style="height: 65px;" -->
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.validity-from' | exp:'':'Vigencia desde' }} *</span>
                        <app-date-picker [name]="this.VALIDITY_FROM_DATE" [form]="formProvision"
                            (onDateChange)="validateShowMessages()"></app-date-picker>
                    </div>
                    <!-- style="height: 65px;" -->
                    <div class="flex-column flex-45">
                        <!-- To -->
                        <ng-container *ngIf="!!this.isAddingAuthorization ||
                            (!this.isAddModeProvision && !!this.provisionFeeToWork.toDate); else vigencyNotRequired">
                            <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.validity-to' | exp:'':'Vigencia hasta' }} *</span>
                        </ng-container>
                        <ng-template #vigencyNotRequired>
                            <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.vigencia-hasta' | exp:'':'Vigencia hasta' }}</span>
                        </ng-template>
                        <app-date-picker [name]="this.VALIDITY_TO_DATE" [form]="formProvision"
                            (onDateChange)="onDateChangeValidityToDate($event)"></app-date-picker>
                    </div>
                </div>
                <div class="flex-column align-start-start">
                    <div *ngIf="showAlertMsg" class="flex-row align-start-start gap-0-5em">
                        <span class="subtitle-4">{{ this.alertMsg }}</span>
                        <mat-icon style="cursor: pointer; z-index: 10; font-size: 20px;" [color]="'accent'"
                            (mouseover)="practiceExistHelp()" (mouseout)="practiceExistHelp()" cdkOverlayOrigin
                            #originOverlay="cdkOverlayOrigin">help_outline
                        </mat-icon>

                        <!-- Alert msg if practice exist -->
                        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOffsetX]="30"
                            [cdkConnectedOverlayOffsetY]="-30" [cdkConnectedOverlayOrigin]="originOverlay"
                            [cdkConnectedOverlayOpen]="isOpen" [cdkConnectedOverlayWidth]="200">
                            <div class="flex-column flecha-lado-izquierdo-arriba">
                                <div class="bg-secondary-lighter mat-font-verysmall-px pxs-2 pys-1">
                                    <div class="flex-column">
                                        <span>{{ 'modules.cases.provisions-detail.la-duplicacion-de-practicas-permite' | exp:'':'La duplicación de prácticas permite tener la misma práctica con dos valores distintos en el mismo periodo de tiempo.' }}</span>
                                        <span>{{ 'modules.cases.provisions-detail.messages.edit-specialty-hint' | exp:'':'Si desea editar o actualizar la especialidad, utilice el icono "Actualizar" que esta sobre la práctica.' }}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                    <div *ngIf="showPracticeAndAgreementExistent" style="max-width: 500px;" class="mbs-3">
                        <span class="subtitle-4">
                            {{ 'modules.cases.provisions-detail.esta-practica-fue-parte-del-esquema-prestacional' | exp:'':'Esta práctica fue parte del esquema prestacional y existen acuerdos prestacionales vigentes que se incluirán dentro de esta.' }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="flex-row" *ngIf="!isSelfCareProvisionForm()">
                <!-- Fee  input -->
                <div class="flex-column flex-45" *ngIf="!this.showTxtWithOutArrangement">
                    <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.sale-price' | exp:'':'Valor venta' }} *</span>
                    <app-number-input class="" [name]="this.FEE" [form]="this.formProvision" [money]="true"
                        [minValue]="0">
                    </app-number-input>
                </div>

                <!-- Grid fees list / Price list -->
                <div *ngIf="this.showTxtWithOutArrangement" class="border-filters grid-fees-list px-2 mbs-4" [ngClass]="{'grid-fees-list-columns-2': !!this.arrangementItemsByPractice,
                                'grid-fees-list-columns-1': !this.arrangementItemsByPractice}">
                    <ng-container *ngIf="!!this.arrangementItemsByPractice; else emptyMessage">
                        <div class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.valor-venta' | exp:'':'Valor venta' }}</div>
                        <div class="subtitle-3 text-primary-darker">{{ 'modules.cases.evolutions.multi-select.category-select.label-date' | exp:'':'Período' }}</div>
                        <ng-container *ngFor="let item of this.arrangementItemsByPractice">
                            <div class="body-3">
                                {{item.fee != -1
                                ? (item.fee.toFixed(2) | currency: 'ARS':'symbol':'1.2')
                                : ('modules.cases.provisions-detail.labels.not-defined' | exp:'':'No definido')
                                }}
                            </div>
                            <div class="body-3">
                                {{ item.fromDate | date: 'dd/MM/yyyy' }} -
                                {{ !!item.toDate ? (item.toDate | date: 'dd/MM/yyyy') : ('modules.cases.provisions-detail.labels.onwards' | exp:'':'en adelante') }}
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-template #emptyMessage class="grid-columns-1">
                        <span *ngIf="existPriceList" class="body-3 text-primary" style="text-align: center;">{{ 'modules.cases.provisions-detail.debe-seleccionar-una-practica-para-ver-la-lista' | exp:'':'Debe seleccionar una práctica para ver la lista de valores de venta e ingresar la vigencia' }}</span>
                        <span *ngIf="!existPriceList" class="body-3 text-primary" style="text-align: center;">{{ 'modules.cases.provisions-detail.no-hay-valores-de-venta-definidos-para-el-convenio' | exp:'':'No hay valores de venta definidos para el convenio en el rango de fechas especificado' }}</span>
                    </ng-template>
                </div>
            </div>

            <!-- Authorization -->
            <div *ngIf="isShowAuth" class="separator separator-center mts-1 flex-100">
                <span class="mx-2 text-primary-darker">
                    {{ 'modules.cases.provisions-detail.autorizacion' | exp:'':'Autorización' }}
                </span>
            </div>

            <app-checkbox-input *ngIf="isShowAuth" class="flex-1-1-auto mbs-2" [labelPosition]="'before'"
                [form]="this.formProvision" [label]="checkboxAuthorizationText" [name]="this.IS_ADDING_AUTHORIZATION"
                (change)="onChangeCheckAut($event, 'this.formProvision')">
            </app-checkbox-input>
            <div *ngIf="this.formProvision.get(this.IS_ADDING_AUTHORIZATION).value" [formGroupName]="this.AUTHORIZATION"
                class="flex-column flex-100">
                <div class="flex-row space-between">
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.authorization-number' | exp:'':'Número de autorización' }} *</span>
                        <app-text-input [name]="this.AUTHORIZATION_NUMBER" [form]="this.formAuthorization">
                        </app-text-input>
                    </div>
                </div>
                <div class="flex-row align-space-between-center">
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.observaciones-de-la-autorizacion' | exp:'':'Observaciones de la autorización' }}</span>
                        <app-text-area-input class="flex-100" [hint]="('modules.cases.provisions-detail.placeholders.optional' | exp:'':'Opcional')"
                            [name]="this.AUTHORIZATION_OBSERVATIONS" [form]="this.formAuthorization" [maxLength]="120">
                        </app-text-area-input>
                    </div>
                    <div class="flex-column flex-45">
                        <div style="height: 25px;">
                            <span class="subtitle-3 text-validation-error" *ngIf="this.photoEvolutionB64 == null">
                                {{ 'modules.cases.provisions-detail.archivo-requerido' | exp:'':'Archivo requerido' }}
                            </span>
                        </div>
                        <file-pond #myPond [options]="pondOptions" (oninit)="pondHandleInit()"
                            (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)"
                            (onaddfilestart)="pondHandleProcessFile($event)" id="Case_fileSelector"
                            class="filepond--panel-root" fxFlex="48">
                        </file-pond>
                    </div>
                </div>
            </div>

            <mat-error class="mls-3" *ngIf="
               this.formAuthorization.errors &&
               (this.formAuthorization.dirty || this.formAuthorization.touched)" class="align-start-center">
                <mat-icon class="text-warn mrs-2">error_outline</mat-icon>
                {{ objectValues(this.formAuthorization.errors)[0] }}
            </mat-error>

            <!-- Bottom -->
            <div class="flex-column">
                <!-- <mat-error *ngIf="this.formProvision?.errors['fromToDate']" class="subtitle-3"
                    style="text-align: center">{{ 'modules.cases.provisions-detail.rango-de-fechas-de-vigencia-incorrecto' | exp:'':'Rango de fechas de vigencia incorrecto' }}</mat-error> -->
                <div class="flex-row mts-3 flex-100 align-space-evenly-center">
                    <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()"
                        [disabled]="
                     (isLoadingUpdatingProvision$ | async) || (isLoadingCreatingProvision$ | async)">
                        {{ 'common.cancel' | exp:'':'Cancelar' }}
                    </button>

                    <button mat-flat-button [color]="'primary'" type="submit" [disabled]="
                        (isLoadingUpdatingProvision$ | async) ||
                        (isLoadingCreatingProvision$ | async) ||
                        !this.formProvision.valid ||
                        this.disabledButtonSubmitUpdateProvision ||
                        (this.photoEvolutionB64 == null &&
                            this.formProvision.get(this.IS_ADDING_AUTHORIZATION).value)">
                        <span
                            *ngIf="!(isLoadingUpdatingProvision$ | async) && !(isLoadingCreatingProvision$ | async); else loadingIcon">{{
                            this.actionProvision }}</span>
                        <ng-template #loadingIcon>
                            <mat-icon>
                                <mat-spinner color="accent" diameter="20"> </mat-spinner>
                            </mat-icon>
                        </ng-template>
                    </button>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<!-- ADD & UPDATE AGREEMENT -->
<ng-template #agreementTemplate>
    <form *ngIf="this.formAgreement" [formGroup]="this.formAgreement" (submit)="onClickConfirmFormAgreement()">
    <div class="flex-column">

        <!-- Spinner -->
            <div class="spinner-hover" *ngIf="(isLoadingGettingProviders$ | async) && this.isAddModeAgreement">
                <mat-spinner color="primary" diameter="40"></mat-spinner>
            </div>

                <!-- Select providers -->
                @if (isSelfCareAgreementForm()) {
                <div class="flex-row flex-100 gap-5em self-care-agreement-form-provider">
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.provider' | exp:'':'Prestador' }}</span>
                        <div class="flex-row align-start-center self-care-agreement-cell">
                            <app-patient-provider-cell [patient]="case?.patient"></app-patient-provider-cell>
                        </div>
                    </div>
                </div>
                } @else {
                <div class="flex-row flex-100 gap-5em">
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.provider' | exp:'':'Prestador' }} *</span>
                        @if( actionAgreement === ('common.update' | exp:'':'Actualizar') || actionAgreement === ('modules.cases.provisions-detail.menu.correct' | exp:'':'Corregir')) {
                            <div class="readonly-container">
                                <mat-form-field appearance="outline" class="flex-100">
                                  <!-- <mat-label>Prestador</mat-label> -->
                                  <input matInput [value]="this.formAgreement.get(this.PROVIDER_NAME).value" [readonly]="true" class="flex-85 text-ellipsis" />
                                  @if(!agreementToWork.provider.active){
                                      <span matSuffix class="custom-chip flex-15">{{ ('modules.cases.provisions-detail.labels.inactive' | exp:'':'Inactivo')  }}</span>
                                  }
                                </mat-form-field>
                              </div>
                        } @else {
                        <app-select-searching-input [hidden]="!this.isAddModeAgreement" [name]="this.PROVIDER"
                            [elements]="this.providers"
                            [defaultValue]="this.isAddModeAgreement ? null : this.agreementToWork.provider.id"
                            [nameSearching]="this.PROVIDER_SEARCHING" [form]="this.formAgreement"
                            [placeholder]="('modules.cases.provisions-detail.seleccione-el-prestador' | exp:'':'Seleccione el prestador')" [calculateId]="this.calculateIdProvider"
                            [calculateName]="this.calculateNameProvider"
                            [placeholderNoValue]="('modules.cases.provisions-detail.placeholders.no-results' | exp:'':'Sin resultados')"
                            [placeholderSearching]="('modules.cases.provisions-detail.placeholders.search-provider' | exp:'':'Buscar prestador...')" [disabled]="!this.isAddModeAgreement">
                        </app-select-searching-input>
                        <app-text-input [form]="this.formAgreement" [hidden]="this.isAddModeAgreement"
                            [name]="this.PROVIDER_NAME">
                        </app-text-input>
                        }
                    </div>
                    <!-- Filter by region -->
                    <div *ngIf="actionAgreement === ('common.add' | exp:'':'Crear')" class="flex-row flex-50 cursor-pointer gap-0-3em align-start-center"(click)="this.openSpecialtiesMap()">
                        <mat-icon class="text-secondary" [svgIcon]="'FindProvider-enabled-primary-27x27'"></mat-icon>
                        <span class="subtitle-3 text-primary-darker" style="align-self:center;">{{ 'modules.cases.provisions-detail.buscar-prestador' | exp:'':'Buscar prestador' }}</span>
                    </div>
                </div>
                }


                <!-- Agreement fromDate -> toDate -->
                <div class="flex-row flex-100 flex-row-wrap gap-5em">
                    <div class="flex-column flex-40">
                        <span class="subtitle-3 text-primary-darker max-content">{{ 'modules.cases.provisions-detail.labels.validity-from' | exp:'':'Vigencia desde' }} *</span>
                        <app-date-picker [name]="this.AGREEMENT_FROM_DATE" [form]="formAgreement"
                            (onDateChange)="onClickDateFrom($event)" class="max-content">
                        </app-date-picker>
                    </div>
                    <div class="flex-column flex-40"
                        *ngIf="this.isAddModeAgreement || (!this.isAddModeAgreement && !this.isUpdateModeAgreement)">
                        <span class="subtitle-3 text-primary-darker max-content">{{ 'modules.cases.provisions-detail.vigencia-hasta' | exp:'':'Vigencia hasta' }}</span>
                        <app-date-picker [name]="this.AGREEMENT_TO_DATE" [form]="formAgreement"
                            (onDateChange)="onClickDateTo($event)" class="max-content"></app-date-picker>
                    </div>
                </div>

                <!-- Fee -->
                @if (!isSelfCareAgreementForm()) {
                <ng-container *ngIf="!!this.isAddModeAgreement; else updateAgreement">
                    <div class="flex-column flex-40">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.cost' | exp:'':'Costo' }} *</span>
                        <app-number-input [name]="this.AGREEMENT_PROVISION_FEE" [minValue]="0" [form]="this.formAgreement" [money]="true">
                        </app-number-input>
                    </div>
                </ng-container>

                <ng-template #updateAgreement>
                        <mat-radio-group class="flex-row gap-5em" formControlName="radioButton" (change)="clickRadiobuttonAgreementCost($event)" name="radioButton">
                            <div class="flex-column flex-40">
                                <mat-radio-button class="subtitle-3 text-primary-darker"
                                    [value]="'cost'">{{ 'modules.cases.provisions-detail.labels.cost' | exp:'':'Costo' }}</mat-radio-button>
                                <app-number-input [name]="this.AGREEMENT_PROVISION_FEE" [minValue]="0"
                                    [form]="this.formAgreement" [money]="true" (change)="this.updateMargin()">
                                </app-number-input>
                            </div>
                            <div class="flex-column flex-40"  *ngIf="!this.isAddModeAgreement && this.isUpdateModeAgreement">
                                <mat-radio-button class="subtitle-3 text-primary-darker" [value]="'margin'">{{ 'modules.cases.provisions-detail.margen-aplicado-sobre-el-valor' | exp:'':'Margen aplicado sobre el valor' }}</mat-radio-button>
                                <app-number-input [name]="this.AGREEMENT_MARGIN" [form]="this.formAgreement" (change)="this.updateCost()" [suffix]="'%'">
                                </app-number-input>
                            </div>
                        </mat-radio-group>
                </ng-template>
                }

                <!-- Actions Btns -->
                <div class="flex-row flex-100 flex-row-wrap gap-5em align-center-center">
                    <button mat-stroked-button [color]="'primary'" type="button"
                        (click)="onClickCloseDialogAgreementTemplate()"
                        [disabled]="isLoadingUpdatingAgreement$ | async">
                        {{ 'common.cancel' | exp:'':'Cancelar' }}
                    </button>
                    <!-- BUTTON create or update -->
                    <button mat-flat-button [color]="'primary'" type="submit" [disabled]="(isLoadingUpdatingAgreement$ | async) || !canSubmitAgreementForm()">
                        <span *ngIf="!(isLoadingUpdatingAgreement$ | async) && !(isLoadingCreatingAgreement$ | async); else loadingIcon">{{ this.actionAgreement }}</span>
                        <ng-template #loadingIcon>
                            <mat-icon>
                                <mat-spinner color="accent" diameter="20"> </mat-spinner>
                            </mat-icon>
                        </ng-template>
                    </button>
                </div>

        </div>
    </form>
</ng-template>

<!-- UPDATE AUTHORIZATION -->
<ng-template #updateAuthorizationTemplate>
    <div class="flex-column">
        <form *ngIf="this.formAuthorization" class="flex-column flex-100" [formGroup]="this.formAuthorization"
            (submit)="onClickCreateAuthorization()">
            <div class="flex-row align-space-between-center gap-2em">
                <div class="flex-row">
                    <div class="flex-column">
                        <span class="subtitle-3 text-primary-darker bs-0">
                            {{ 'modules.cases.provisions-detail.labels.authorization-number' | exp:'':'Número de autorización' }} *
                        </span>
                        <app-text-input [name]="this.AUTHORIZATION_NUMBER" [form]="this.formAuthorization"
                            [placeholder]="('modules.cases.provisions-detail.labels.authorization-number' | exp:'':'Número de autorización')"> *
                        </app-text-input>
                    </div>
                </div>
                <div class="flex-row align-end-center flex-gap-small">
                    <div class="flex-column" [ngClass]="{'disabledElements' : !!this.provisionFeeSelectedToAutorize.fromDate}">
                        <span class="subtitle-3 text-primary-darker bs-0">
                            {{ 'modules.cases.provisions-detail.labels.from' | exp:'':'Desde' }} *
                        </span>
                        <app-date-picker [name]="this.AUTHORIZATION_FROM_DATE" [form]="formAuthorization"
                            [disabled]="true" [readonly]="true">
                        </app-date-picker>
                    </div>
                    <div class="flex-column" [ngClass]="{'disabledElements' : !!this.provisionFeeSelectedToAutorize.toDate}">
                        <span class="subtitle-3 text-primary-darker bs-0">
                            {{ 'modules.cases.provisions-detail.labels.to' | exp:'':'Hasta' }} *
                        </span>
                        <app-date-picker [name]="this.AUTHORIZATION_TO_DATE" [form]="formAuthorization"
                            [disabled]="!!this.provisionFeeSelectedToAutorize.toDate"
                            [readonly]="!!this.provisionFeeSelectedToAutorize.toDate">
                        </app-date-picker>
                    </div>
                </div>
            </div>
            @if(provisionFeeSelectedToAutorize.toDate){
            <div class="flex-100 flex-row align-end-end" style="transform: translate(0, -70%);">
                <span class="text-secondary" style="font-size: smaller;;"><i> {{ 'modules.cases.provisions-detail.para-editar-las-fechas-de-vigencia-ingresar-a-corregir' | exp:'':'Para editar las fechas de vigencia, ingresar a “corregir” desde el menú de la práctica' }}</i> </span>
            </div>
            }
            <div class="flex-row gap-2em">
                <div class="flex-column flex-52">
                    <span class="subtitle-3 text-primary-darker bs-0">
                        {{ 'modules.cases.provisions-detail.observaciones-de-la-autorizacion' | exp:'':'Observaciones de la autorización' }}
                    </span>
                    <app-text-area-input class="flex-100" [height]="36" [hint]="('modules.cases.provisions-detail.placeholders.optional' | exp:'':'Opcional')"
                        [name]="this.AUTHORIZATION_OBSERVATIONS" [form]="this.formAuthorization"
                        [placeholder]="('modules.cases.provisions-detail.ingrese-el-texto-aqui' | exp:'':'Ingrese el texto aquí')" [maxLength]="120">
                    </app-text-area-input>
                </div>
                <div class="flex-column flex-46">
                    <span class="subtitle-3 text-validation-error" *ngIf="this.photoEvolutionB64 == null">
                        {{ 'modules.cases.provisions-detail.archivo-requerido' | exp:'':'Archivo requerido' }}
                    </span>
                    <file-pond #myPond [options]="pondOptions" (oninit)="pondHandleInit()" required="true"
                        (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)"
                        (onaddfilestart)="pondHandleProcessFile($event)" id="Case_fileSelector"
                        class="filepond--panel-root">
                    </file-pond>
                </div>
            </div>
            <div class="flex-100 mts-3 gap-15px flex-row align-space-evenly-start flex-column-xs">
                <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()"
                    [disabled]="isLoadingUpdatingProvision$ | async">
                    {{ 'common.cancel' | exp:'':'Cancelar' }}
                </button>
                <button mat-flat-button [color]="'primary'" type="submit"
                    [disabled]=" (isLoadingUpdatingProvision$ | async) ||
                        !this.formAuthorization.valid ||
                        this.photoEvolutionB64 == null">
                    <span *ngIf="!(isLoadingUpdatingProvision$ | async); else loadingIcon">{{('common.save' | exp:'':'Guardar')}}</span>
                    <ng-template #loadingIcon>
                        <mat-icon>
                            <mat-spinner color="accent" diameter="20"> </mat-spinner>
                        </mat-icon>
                    </ng-template>
                </button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #showAuthorizations>
    <!-- GRID -->
    <ng-container *ngIf="!(this.isLoadingGetAuthorizations$ | async); else loadingAuthorizations">
        <div *ngIf="this.authorizations.length > 0" class="grid-to-auths grid-to-auths-cant-columns-4">
            <!-- TITLES -->
            <div></div>
            <div style="text-align: left;"><span class="subtitle-3">{{ 'modules.cases.provisions-detail.numero' | exp:'':'Número' }}</span></div>
            <div style="text-align: left;"><span class="subtitle-3">{{ 'modules.cases.provisions-detail.labels.date' | exp:'':'Fecha' }}</span></div>
            <div></div>
            <!-- CONTENT -->
            <ng-container *ngFor="let authorization of authorizations">
                <div>
                    <mat-icon [svgIcon]="'Lines-gray'"></mat-icon>
                </div>
                <div style="align-self: center;">
                    <span class="subtitle-3 text-primary-darker"># {{ authorization.authorizationNumber }}</span>
                </div>
                <div style="align-self: center;">
                    <span class="body-3">{{ authorization.fromDate | date: 'dd/MM/yyyy' }} -
                        {{ authorization.toDate | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div>
                    <a mat-button [disabled]="!authorization.evolutionId" [ngClass]="{
                     'text-primary': !!authorization.evolutionId,
                     'text-secondary': !authorization.evolutionId
                  }" style="text-decoration: underline !important;"
                        (click)="authorization.evolutionId && showAuthEvolution(authorization)">{{ 'modules.cases.provisions-detail.ver-autorizacion' | exp:'':'Ver Autorización' }}</a>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <!-- Message no auths -->
    <ng-template #noAuthorizations>
        <div class="flex-row-wrap align-center-center">
            <span class="text-secondary-darker">
                {{ 'modules.cases.provisions-detail.aun-no-se-han-cargado-autorizaciones' | exp:'':'Aún no se han cargado autorizaciones' }}
            </span>
        </div>
    </ng-template>

    <!-- Spinner -->
    <ng-template #loadingAuthorizations>
        <div class="flex-row align-center-center full-height">
            <mat-spinner diameter="60"></mat-spinner>
        </div>
    </ng-template>
</ng-template>

<!-- Suspend provision-fee -->
<ng-template #suspendTemplate>
    <form (submit)="onClickSuspendProvisionFee()">
        <!-- Spinner -->
        <div class="spinner-hover" *ngIf="false">
            <mat-spinner color="primary" diameter="40"></mat-spinner>
        </div>
        <div class="flex-column">
            <div class="flex-row-wrap align-space-around-center">
                <!-- Practice -->
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">
                        {{ 'modules.cases.provisions-detail.practica' | exp:'':'Práctica' }}
                    </span>
                    <app-text-input [name]="this.PRACTICE" [form]="this.formSuspend" [placeholder]="('modules.cases.provisions-detail.practica' | exp:'':'Práctica')">
                    </app-text-input>
                </div>
                <!-- Validity / Vigencia -->
                <div class="flex-row align-center-center gap-0-5 flex-40">
                    <div class="flex-column flex-50">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.from' | exp:'':'Desde' }}</span>
                        <app-date-picker [name]="this.VALIDITY_FROM_DATE" [form]="formSuspend"></app-date-picker>
                    </div>
                    <div class="flex-column flex-50">
                        <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.provisions-detail.labels.to' | exp:'':'Hasta' }}</span>
                        <app-date-picker [name]="this.VALIDITY_TO_DATE" [form]="formSuspend"></app-date-picker>
                    </div>
                </div>
            </div>
            <div class="flex-100 mts-3 gap-15px flex-row align-space-evenly-start flex-column-xs">
                <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()"
                    [disabled]="isLoadingUpdatingProvision$ | async">
                    {{ 'common.cancel' | exp:'':'Cancelar' }}
                </button>
                <button mat-flat-button [color]="'primary'" type="submit"
                    [disabled]="!this.formSuspend.valid || (isLoadingUpdatingProvision$ | async)">
                    <span *ngIf="!(isLoadingUpdatingProvision$ | async); else loadingIcon">{{('common.save' | exp:'':'Guardar')}}</span>
                    <ng-template #loadingIcon>
                        <mat-icon>
                            <mat-spinner color="accent" diameter="20"> </mat-spinner>
                        </mat-icon>
                    </ng-template>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<!-- Patient and providers in google-maps -->
<ng-template #specialtiesMap>
    <app-specialties-providers-pois [specialtyId]="this.specialtySelected.id" [screenCalling]="'app-provisions-detail'"
        [patient]="this.case.patient" [provision]="this.provisionToWork" [specialty]="this.specialtySelected">
    </app-specialties-providers-pois>
</ng-template>

<mat-menu #menuActions="matMenu">
    <ng-template matMenuContent let-provisionFee="provisionFee" let-provision="provision">
        <button mat-menu-item (click)="this.openUpdateAuthorizationDialog(provisionFee)" id="addAuthorizationButton"
            *ngIf="!provisionFee.authorization">
            {{ 'modules.cases.provisions-detail.menu.authorize' | exp:'':'Autorizar' }}
        </button>
        <button mat-menu-item (click)="this.openUpdateProvisionDialogWithRetroactiveMode(provision, provisionFee)"
            id="updProvisionFee">
            {{ 'modules.cases.provisions-detail.menu.renew' | exp:'':'Renovar' }}
        </button>
        <button mat-menu-item (click)="this.openSuspendProvisionFee(provision, provisionFee)" id="suspendProvisionFee">
            {{ 'modules.cases.provisions-detail.menu.finish' | exp:'':'Finalizar' }}
        </button>
        <button mat-menu-item (click)="this.amendProvisionFee(provision, provisionFee)" id="amendProvisionFee">
            {{ 'modules.cases.provisions-detail.menu.correct' | exp:'':'Corregir' }}
        </button>
        <button mat-menu-item (click)="this.deleteProvisionFee(provision, provisionFee)" id="deletedProvisionFee">
            {{ 'modules.cases.provisions-detail.menu.delete' | exp:'':'Eliminar' }}
        </button>
        <!-- <button mat-menu-item (click)="this.openAuthorizations(provision, provisionFee)" id="openAuths">
            {{ 'modules.cases.provisions-detail.mas-info' | exp:'':'Más info' }}
        </button> -->
    </ng-template>
</mat-menu>

<mat-menu #menuAgreement="matMenu">
    <ng-template matMenuContent let-agreement="agreement" let-provision="provision">
        <button mat-menu-item (click)="this.openUpdateAgreementDialog(provision, agreement)" id="updateAgreement">
            {{ 'modules.cases.provisions-detail.menu.update' | exp:'':'Actualizar' }}
        </button>
        <button mat-menu-item (click)="this.openFixAgreementDialog(provision, agreement)" id="fixAgreement">
            {{ 'modules.cases.provisions-detail.menu.correct' | exp:'':'Corregir' }}
        </button>
        <button mat-menu-item (click)="onClickDeleteAgreement(provision, agreement)" id="deleteAgreement" [disabled]="
            !this.case.active ||
            (!!this.case['caseDerivations'] && this.case['caseDerivations'].length > 0)
        ">
            {{ 'modules.cases.provisions-detail.menu.delete' | exp:'':'Eliminar' }}
        </button>
    </ng-template>
</mat-menu>

<mat-menu #menuGlobalActions="matMenu">
    <ng-template matMenuContent let-provisionFee="provisionFee" let-provision="provision">
        <button mat-menu-item (click)="exportProvisionFees(true)">{{ 'modules.cases.provisions-detail.exportar-como-pdf' | exp:'':'Exportar como .pdf' }}</button>
        <button mat-menu-item (click)="exportProvisionFees(false)">{{ 'modules.cases.provisions-detail.exportar-como-doc' | exp:'':'Exportar como .doc' }}</button>
    </ng-template>
</mat-menu>
